import AnnualLeasingAmountError from './AnnualLeasingAmountError';
class TargetAnnualLeasingNotReachable extends AnnualLeasingAmountError {
    constructor(options) {
        super('TARGET_ANNUAL_LEASING_NOT_REACHABLE', options);
    }
}
export default TargetAnnualLeasingNotReachable;
